import { render, staticRenderFns } from "./BindingShop.vue?vue&type=template&id=cd360ab8"
import script from "./BindingShop.vue?vue&type=script&lang=js"
export * from "./BindingShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports